import { createFileRoute } from '@tanstack/react-router'

import { MembersPage } from '@/pages/group-members/Members.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups/$groupId',
)({
  component: MembersPage,
})
